import * as React from 'react'
import {
    extractClassNamesFromProps,
    BaseComponentProps,
} from '../Common/extractClassNamesFromProps'
import * as st from './DVUI.module.scss'

export const DVUI: React.ComponentType<BaseComponentProps> = props => {
    const className = extractClassNamesFromProps(props, st.base)
    return <div className={className}>{props.children}</div>
}

// Add displayName to preserve the component name on snapshot testing
DVUI.displayName = 'DVUI'
